import {
  Children,
  cloneElement,
  isValidElement,
  useState,
  type ReactNode,
} from 'react';
import type { AccordionProps } from '../Accordion/Accordion';
import { AccordionGroupContainer } from './AccordionGroup.styles';

interface AccordionGroupProps {
  toggle?: 'single' | 'all';
  children: ReactNode;
}

const AccordionGroup = ({
  toggle = 'single',
  children,
}: AccordionGroupProps) => {
  const toggleSingle = toggle === 'single';
  const [activeAccordions, setActiveAccordions] = useState<number[]>([]);

  return (
    <AccordionGroupContainer>
      {Children.toArray(children).map((child, id) => {
        if (isValidElement<AccordionProps>(child)) {
          return cloneElement(child, {
            onToggle: (open: boolean) => {
              if (toggleSingle) {
                setActiveAccordions(open ? [id] : []);
              } else {
                if (open) {
                  setActiveAccordions((state) => [...state, id]);
                } else {
                  setActiveAccordions((state) =>
                    state.filter((accordionId) => accordionId !== id)
                  );
                }
              }
            },
            isOpen: activeAccordions.includes(id),
            ...child.props,
          });
        }

        return child;
      })}
    </AccordionGroupContainer>
  );
};

export default AccordionGroup;
